interface VaultTvl {
  tvlUsd: number | string;
}

export const sumVaultTvlUsd = (
  ...vaultGroups: Array<readonly VaultTvl[] | undefined>
): number =>
  vaultGroups.reduce(
    (total, vaults) =>
      total +
      (vaults?.reduce((groupTotal, vault) => {
        const tvlUsd = Number(vault.tvlUsd);
        return groupTotal + (Number.isFinite(tvlUsd) ? tvlUsd : 0);
      }, 0) ?? 0),
    0
  );
